import { TextInput, View, Text, StyleSheet } from 'react-native'
import CurrencyInput from 'react-native-currency-input'
import ExchangeIcon from '@/src/assets/icons/Exchange'
import { formatNumber } from '../../common/utils/general'
import { openInAppBrowser } from '../../common/utils/openInAppBrowser'
import * as CardApplication from '@/src/experiences/card-application'
import { DesignSystem } from '@/src/design-system'
import { mesaColorNames, typography } from '@/src/common/theme'
import { Skeleton } from 'moti/skeleton'

export function SelectCreditAmount({
  maxDollarValue,
  pointsToRedeem,
  creditAmount,
  setCreditAmount,
}: {
  maxDollarValue?: number | 'loading'
  pointsToRedeem: number
  creditAmount: number
  setCreditAmount: (value: number) => void
}) {
  const cardPolicyAndProcedures =
    CardApplication.Statsig.ParameterStores.useCardPolicyAndProcedures()
  const launchTerms = () =>
    void openInAppBrowser(
      cardPolicyAndProcedures.get(
        'cardholder_rewards_terms_of_use',
        'https://mesamember.com/legal/mesa-membership-terms-and-conditions',
      ),
      'Terms and Conditions',
    )

  return (
    <DesignSystem.Card style={styles.whiteBlock}>
      <Text style={typography['label/sm-bold']}>Select Credit Amount</Text>
      <View style={styles.inputRow}>
        <View style={styles.inputContainer}>
          <Text style={typography['label/sm-bold']}>Credit</Text>
          {maxDollarValue === 'loading' ? (
            <Skeleton
              colorMode="light"
              width="100%"
              height={styles.input.height}
              radius={styles.input.borderRadius}
            />
          ) : (
            <CurrencyInput
              value={creditAmount}
              onChangeValue={(value) => setCreditAmount(value ?? 0)}
              prefix="$"
              delimiter=","
              separator="."
              precision={2}
              minValue={0}
              maxValue={maxDollarValue}
              style={[typography['label/md-regular'], styles.input]}
              returnKeyType="done"
            />
          )}
        </View>
        <View style={styles.exchangeIcon}>
          <ExchangeIcon color={mesaColorNames['semantic/fg/base #131214']} />
        </View>
        <View style={styles.inputContainer}>
          <Text style={typography['label/sm-bold']}>Points</Text>
          <TextInput
            style={[typography['label/md-regular'], styles.pointsDisplay]}
            value={formatNumber(pointsToRedeem)}
            keyboardType="numeric"
            editable={false}
          />
        </View>
      </View>
      <Text style={[typography['label/sm-regular'], styles.termsText]} onPress={launchTerms}>
        Terms and conditions
      </Text>
    </DesignSystem.Card>
  )
}

const styles = StyleSheet.create({
  whiteBlock: {
    borderRadius: 12,
    padding: 16,
    gap: 24,
  },
  inputRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
  inputContainer: {
    flexDirection: 'column',
    flex: 1,
    gap: 8,
  },
  input: {
    borderColor: mesaColorNames['Greyscale/300 #CDD4D5'],
    borderWidth: 1,
    borderRadius: 8,
    paddingHorizontal: 16,
    height: 48,
    color: mesaColorNames['Greyscale/900 #152438'],
  },
  pointsDisplay: {
    paddingHorizontal: 16,
    height: 48,
    color: mesaColorNames['Greyscale/900 #152438'],
  },
  exchangeIcon: {
    top: 10,
  },
  termsText: {
    color: mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'],
  },
})
